import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IModalComponentConfiguration extends CM.DOMComponent.IConfiguration {
	type : 'yesNo' | /** true for yes, false for no **/
		'ok' /** true **/
	;
	hasCancelButton : boolean; /** cancel button force use to returns null **/
};

interface TModalResponse<TValue> {
	responseType : 'yes' | 'no' | 'abort';
	value : TValue;
};

export abstract class ModalComponent<TData, TValue> extends CM.DOMComponent<
	HTMLDivElement,
	ModalComponent<TData, TValue>,
	IModalComponentConfiguration
>
{
	static override initialize() {
		CM.DOMComponent.initialize.call(this);
		this.declareEventType('modal-yes', '*');
		this.declareEventType('modal-no', '*');
		this.declareEventType('modal-abort', '*');
	};


	component_DOM : HTMLDivElement;

	protected abstract onOpen() : Promise<void> | void;

	protected abstract onClose() : Promise<void> | void;

	protected abstract onValidate() : Promise<TValue/* If the modal can be closed.*/ | void/* If not.*/>;

	protected abstract canBeClosed() : Promise<boolean/* If the modal can be closed.*/> | boolean;

	protected data : TData | null = null;
	protected ppack : ReturnType<typeof STD.misc.createPromisePack<TModalResponse<TValue>>> | null = null;

	private async onCloseOrAbortButtonClicked() {
		if (!this.ppack) {
			this.component_throwLibraryError('');
		}
		if (!await this.canBeClosed()) {
			return;
		}
		this.ppack.resolve({
			responseType : 'abort',
			value :        <any> void 1
		});
	};

	private async onYesButtonClicked() {
		if (!this.ppack) {
			this.component_throwLibraryError('');
		}
		const result = await this.onValidate();
		if (result === undefined) {
			return;
		}
		this.ppack.resolve({
			responseType : 'yes',
			value :        <any> result
		});
	};

	async use(data : TData) : Promise<TModalResponse<TValue>> {
		this.ppack = STD.misc.createPromisePack();
		this.data = data;
		await this.onOpen();
		let result = await this.ppack.promise;
		await this.onClose();
		this.ppack = null;
		this.data = null;
		await this.dispatchEvent(`modal-${ result.responseType }`, {
			subType : this.id,
			details : {
				value : result.value
			}
		});
		return result;
	};

	protected constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IModalComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
		void this.onCloseOrAbortButtonClicked;
		void this.onYesButtonClicked;

	};
};
export namespace NS {
	export const Component = ModalComponent;
	export type  Component = ModalComponent<any, any>;
	export type  Configuration = IModalComponentConfiguration;
}
import manifestXMLSource from './Modal.xml';
import './Modal.scss';

CM.declareAbstract({
	id :       'modal',
	type :     <any> ModalComponent,
	manifest : manifestXMLSource
});
